(function () {
  'use strict';
  var brand = '6a7a1e6ea589dfe14c453093';
  var root = document.querySelector('.ocl-wait-page[data-meta-tracking="true"]');
  if (!root) return;
  var forms = {
    '6ae25e52f70093887ca93da1': 'Pacific Dawn',
    '6ae25f4c9e0ed4983d48002b': 'Golden Tide',
    '6ae26057f70093887ca93ddf': 'Northern Lights'
  };
  var form = root.getAttribute('data-form-id');
  if (!Object.prototype.hasOwnProperty.call(forms, form)) return;
  var pixel = '1103837582352720';
  var key = 'orcalune_product_waitlist_lead_v1:' + form;
  if (!/^(www\.)?orcalune\.com$/.test(window.location.hostname) ||
      window.__orcaluneWaitlistListener) return;
  window.__orcaluneWaitlistListener = true;
  var pending = false, completed = false, eventId, timer, attempts = 0;
  try { completed = window.sessionStorage.getItem(key) === '1'; } catch (_) {}
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return !!privacy && privacy.marketingAllowed() === true &&
        privacy.analyticsProcessingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function send() {
    timer = null;
    if (!pending || completed) return;
    if (!allowed() || typeof window.fbq !== 'function' || !window.fbq.callMethod) {
      if (++attempts < 60) timer = window.setTimeout(send, 250);
      return;
    }
    try {
      window.fbq('trackSingle', pixel, 'Lead', {
        content_name: forms[form], content_category: 'Product waitlist'
      }, {eventID: eventId});
      completed = true;
      pending = false;
      try { window.sessionStorage.setItem(key, '1'); } catch (_) {}
    } catch (_) { pending = false; }
  }
  window.addEventListener('omnisendForms', function (event) {
    var detail = event.detail || {};
    if ((detail.type || detail.eventName) !== 'submit' ||
        detail.brandID !== brand || !detail.form || detail.form.id !== form ||
        pending || completed) return;
    eventId = 'ocl-wait-' + (window.crypto && window.crypto.randomUUID ?
      window.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
    pending = true;
    attempts = 0;
    send();
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (pending && !completed) {
      if (timer) window.clearTimeout(timer);
      attempts = 0;
      send();
    }
  });
}());
